export const SET_USERNAME = "SET_USERNAME";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const SET_REFRESH_TOKEN = "SET_REFRESH_TOKEN";
export const SET_AUTH_TOKEN_EXPIRES = "SET_AUTH_TOKEN_EXPIRES";
export const SET_USER_INFO = "SET_USER_INFO";
export const UPDATE_KID = "UPDATE_KID";
export const RESET_AUTH_STATE = "RESET_AUTH_STATE";
